// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__K97i7","left":"Login_left__ntyCz","right":"Login_right__nkwru","btn":"Login_btn__sdYQa","signup":"Login_signup__-PnNn","head":"Login_head__91ERA"};